import React from "react";
import { useState, useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewCountryList } from "../../Redux/Actions/settingsActions";
import { editCountry } from "../../Redux/Actions/settingsActions";
import TextInput from "../../Global Functions/textInput";
import SelectInput from "../../Global Functions/selectInput";

const EditCountry = () => {
  const { id } = useParams();
  const { countryList } = useSelector((state) => state.country);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [countryData, setCountryData] = useState({
    id: id,
    country_name: "",
    country_code: "",
    country_language_code: "",
    country_language_name: "",
    country_currency_symbol: "",
    country_phone_code: "",
    country_currency: "",
    country_flag: "",
    country_having: "",
  });

  useEffect(() => {
    dispatch(viewCountryList({ page: 1, limit: 10 }));
  }, [dispatch]);

  useEffect(() => {
    const list = countryList?.data || [];
    console.log("id from params =>", id);
    console.log("list =>", list);

    if (list.length > 0) {
      const country = list.find(c => String(c._id) === String(id));
      console.log("matched country =>", country);

      if (country) {
        setCountryData(prev => ({
          ...prev,
          id: id,
          country_name: country.country_name || "",
          country_code: country.country_code || "",
          country_language_code: country.country_language_code || "",
          country_language_name: country.country_language_name || "",
          country_currency_symbol: country.country_currency_symbol || "",
          country_phone_code: country.country_phone_code || "",
          country_currency: country.country_currency || "",
          country_flag: country.country_flag || "",
          country_having: country.country_having || "",
        }));
      }
    }
  }, [countryList, id]);

  const dropdownOptions = ["REGION", "STATE", "PROVINCE", "CITY"];

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await dispatch(editCountry(countryData));
      if (response.statusCode === 200) {
        setCountryData({
          id: id,
          country_name: "",
          country_code: "",
          country_language_code: "",
          country_language_name: "",
          country_currency_symbol: "",
          country_phone_code: "",
          country_currency: "",
          country_flag: "",
          country_having: "",
        });
        navigate("/country");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setCountryData((prevData) => {
      let updatedData = { ...prevData, [name]: value };

      if (name === "country_code") {
        updatedData.country_flag = value.substring(0, 2).toLowerCase() + ".svg";
      }
      if (name === "country_having") {
        updatedData.country_having = value;
      }
      return updatedData;
    });
  };

  return (
    <MainLayout>
      <div className="padding-20 bg-white border-24 grid-span-5" style={{ width: "100%" }}>
        <div className="margin-h-10 flex-container flex-justify-between gap-10">
          <h1>Edit Country</h1>
          <Link to="/country">
            <button className="button-class">View Country List</button>
          </Link>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="margin-h-10 flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label="Country Name"
                value={countryData.country_name}
                name="country_name"
                type="text"
                placeholder="Enter Name"
                onChange={handleAddChange}
              />
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                onChange={handleAddChange}
                name="country_code"
                label="Country ISO Code"
                placeholder="Enter Code"
                type="text"
                value={countryData.country_code}
              />
            </div>
          </div>
          <div className="margin-h-10 flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label="National Language"
                value={countryData.country_language_name}
                onChange={handleAddChange}
                name="country_language_name"
                placeholder="Enter Title"
                type="text"
              />
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                label="Language Code"
                value={countryData.country_language_code}
                onChange={handleAddChange}
                name="country_language_code"
                placeholder="Enter Language Code"
                type="text"
              />
            </div>
          </div>
          <div className="margin-h-10 flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label="Country Currency"
                value={countryData.country_currency}
                onChange={handleAddChange}
                name="country_currency"
                placeholder="Enter Currency"
                type="text"
              />
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                label="Currency Symbol"
                value={countryData.country_currency_symbol}
                onChange={handleAddChange}
                name="country_currency_symbol"
                placeholder="Currency Symbol"
                type="text"
              />
            </div>
          </div>
          <div className="margin-h-10 flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label="Country Phone Code"
                value={countryData.country_phone_code}
                onChange={handleAddChange}
                name="country_phone_code"
                placeholder="Enter Phone Code"
                type="text"
              />
            </div>
            <div style={{ width: "50%" }}>
              <SelectInput
                label="Select Administrative Division"
                name="country_having"
                value={countryData.country_having}
                placeholder="Select An Option"
                onChange={handleAddChange}
                options={
                  Array.isArray(dropdownOptions)
                    ? dropdownOptions.map((option) => ({
                      label: option,
                      value: option,
                    }))
                    : []
                }
              />
            </div>
          </div>
          <div className="flex-end " style={{ margin: "20px auto" }}>
            <Link to="/country">
              <button type="button" className="button-class-white">Cancel</button>
            </Link>
            <button type="submit" className="button-class">
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditCountry;
